import React from 'react';
// @material-ui/core components
import Grid, { GridProps } from '@material-ui/core/Grid';

interface IProps extends GridProps {}

export const GridItem: React.FC<IProps> = ({ children, ...rest }) => {
  return (
    <Grid item {...rest}>
      {children}
    </Grid>
  );
};
